export const getHutk = (): string | undefined => {
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith("hubspotutk="))
    ?.split("=")[1];
};
